@if (initialized) {
    @if (uiMode == 'side') {
        <hc-integration-side-component
                [objectIdentifier]="objectIdentifier"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></hc-integration-side-component>
    } @else {

        <hc-integration-full-component
                [objectIdentifier]="objectIdentifier"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></hc-integration-full-component>
    }

}
